export default __webpack_public_path__ + "img/spotify.d061b570c149514f34f8794cce2314f1.svg";